<template>
  <div>
    <div class="bg-white padding" style="position: relative; z-index: 2" ref="card" v-show="carInformationList.length>0">
      <div class="input-item">
        <div class="line"></div>
        <span class="text-nowrap">已綁定扣繳的車牌</span>
      </div>
      <div class="dark-card">
        <div v-for="(item, i) in carInformationList" :key="i" class="flex border">
          <div>
            <div>{{ item.car_number }}</div>
            <div style="font-size: 14px; color: #c7c7c7">{{ item.car_type === 'C' ? '汽車' : '機車' }}</div>
          </div>
          <div class="more" @click="showDetail(item)"></div>
        </div>
      </div>
    </div>
    <div class="list_null bg-white" v-show="!carInformationList.length">
      <div class="item">
        <img src="../../assets/images/paymentParkingSupport@3x.png" class="image" />
        <div>台北市</div>
        <div>公有停車場支援</div>
      </div>
      <div class="item">
        <img src="../../assets/images/paymentParkingNextday@3x.png" class="image" />
        <div>開啟後</div>
        <div>次日生效</div>
      </div>
      <div class="item">
        <img src="../../assets/images/paymentParkingNotice@3x.png" class="image" />
        <div>主動通知</div>
        <div>扣款結果</div>
      </div>
    </div>

    <div class="bg-white padding">
      <button class="btn btn-primary" @click="$router.push('/carPark/addCarNumber')">新增約定車牌</button>
    </div>

    <div class="padding description">
      <ul class="text-gray2">
        <li>
          台北市
          <span class="text-blue" @click="openExternalLink('https://easywallet.easycard.com.tw/userange/?page=1&s_cls=1506497567&s_cls2=1637654268')">公有路外停車場</span>
          支援「車牌辨識智慧進出」的服務，可於車輛駛離停車場時，以悠遊付預設支付工具自動扣繳停車費。
        </li>
        <li>停管處自營場次、萬華區行政中心地下停車場、松德大樓地下停車場可使用悠遊付錢包、銀行帳戶連結、信用卡（限台新銀行、玉山銀行發卡）進行車牌辨識扣款。</li>
        <li>其餘場次可使用悠遊付錢包、銀行帳戶連結進行車牌辨識扣款。</li>
        <li>停車費為即時扣繳，若扣繳失敗需進行補繳。補繳方式：於接獲通知次日起，可利用「路邊臨時停車費」查詢補繳費用。</li>
        <li>綁定車牌與解除車牌綁定將於設定次日生效。</li>
        <li>如有欠費情況，將被停管處列入黑名單，並於補繳後第四日始得再次使用車牌綁定辨識進場。</li>
        <li>
          如有停車費相關問題，請洽台北市停車管理處客服電話：
          <a href="tel:0227269600" class="text-blue text-underline">(02)2726-9600</a>
          。
        </li>
        <li>註：路邊機車月票、路外停車場月票，請於此頁先行新增約定車牌，進行車號綁定，方得於登記後扣款購票。</li>
      </ul>
    </div>
    <div :class="isListInModify ? 'mask' : ''" ref="mask"></div>
  </div>
</template>

<script>
import { queryCardless, cardlessUnbind } from '../../api/api';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'car-park-list',
  data() {
    return {
      carInformationList: [],
      isListInModify: false,
      checkedItem: {},
    };
  },
  created() {
    window.clickActionSheetItem = this.clickActionSheetItem;
    this.getCarParkList();
    /* if(this.$route.query.p!=null){
                this.setSession({sessionKey: this.$route.query.k, sessionToken: this.$route.query.p});
            }*/
  },
  computed: {
    ...mapGetters(['sessionToken']),
  },
  methods: {
    ...mapActions(['setSession', 'sentApp']),
    openExternalLink(url) {
      this.sentApp({
        action: 'openExternalBrowser',
        payload: { url: url },
      });
    },
    getCarParkList() {
      queryCardless().then((res) => {
        if (res.error === undefined) {
          this.carInformationList = Object.assign(res.car_information_list, this.carInformationList);
        }
      });
    },
    showDetail(item) {
      var payload = {
        action_list: [{ name: '解除約定繳費', action: 'unbind' }],
      };
      this.checkedItem = item;
      this.$store.dispatch('sentApp', {
        action: 'showActionSheet',
        payload: payload,
      });
    },
    clickActionSheetItem(action) {
      if (action === 'unbind') {
        if (confirm('確定要解除約定繳費嗎？\n' + '解除約定後將無法於出場時自動扣繳停車費！')) {
          cardlessUnbind(this.checkedItem).then((res) => {
            if (res.error != null) {
              alert(res.error.message);
            } else {
              alert('解除成功！');
              this.carInformationList.splice(this.checkedItem);
            }
            this.clearCheckItem();
          });
        } else {
          this.clearCheckItem();
        }
      }
    },
    clearCheckItem() {
      this.checkedItem = {};
      this.getCarParkList();
    },
  },
  watch: {
    sessionToken() {
      this.getCarParkList();
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 9pt 0;
}
</style>
